export const heroSliderData = [
  {
    id: 1,
    title: '株式会社 J・T・C',
    subtitle: '旅人倶楽部',
    buttonText: '新着情報',
    buttonAction: 'news', // ニュース一覧ページへ遷移
    backgroundType: 'animation',
    visualType: 'shippou',
    textColor: '#ffffff',
    textPosition: 'center',
  },
  // {
  //   id: 2,
  //   title: '日本の美を体験',
  //   subtitle: 'Experience Japanese Beauty',
  //   buttonText: 'もっと見る',
  //   buttonAction: 'work', // 同じページ内のWORKセクションへスクロール
  //   backgroundType: 'animation',
  //   visualType: 'wave',
  //   textColor: '#ffffff',
  //   textPosition: 'center',
  // },
  {
    id: 3,
    title: 'ご案内　PR',
    subtitle: '三田陶芸の森。特別体験ツアー',
    buttonText: '詳細はこちら',
    buttonAction: 'news/2', 
    backgroundType: 'image',
    backgroundImage: 'https://static.wixstatic.com/media/fa21f0_b5dbe84e7f1b45f3900e28486c708d5a~mv2.jpg/v1/fill/w_1766,h_910,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/fa21f0_b5dbe84e7f1b45f3900e28486c708d5a~mv2.jpg',
    textColor: '#ffffff',
    textPosition: 'center',
    textBlockBackground: true, 
    textBlockBackgroundColor: 'rgba(0, 0, 0, 0.4)', 
  },

  // 画像の例（コメントアウト）
  // {
  //   id: 4,
  //   title: '京都の魅力',
  //   subtitle: 'Discover Kyoto',
  //   buttonText: '探索する',
  //   buttonAction: 'work', // スクロール
  //   backgroundType: 'image',
  //   backgroundImage: '/hero-slides/kyoto.jpg',
  //   textColor: '#ffffff',
  //   textPosition: 'center',
  //   textBlockBackground: true,
  //   textBlockBackgroundColor: 'rgba(0, 0, 0, 0.5)',
  // },
  
  // ページ遷移の例（コメントアウト）
  // {
  //   id: 5,
  //   title: '会社情報',
  //   subtitle: 'About Us',
  //   buttonText: '詳しく見る',
  //   buttonAction: 'about', // 会社概要ページへ遷移
  //   backgroundType: 'gradient',
  //   backgroundGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  //   textColor: '#ffffff',
  //   textPosition: 'center',
  // },
  
  // 特定のニュース記事への遷移例（コメントアウト）
  // {
  //   id: 6,
  //   title: '重要なお知らせ',
  //   subtitle: 'Important Notice',
  //   buttonText: '詳細を見る',
  //   buttonAction: 'news/1', // ニュース詳細ページ（ID: 1）へ遷移
  //   backgroundType: 'image',
  //   backgroundImage: '/hero-slides/notice.jpg',
  //   textColor: '#ffffff',
  //   textPosition: 'center',
  //   textBlockBackground: true,
  //   textBlockBackgroundColor: 'rgba(0, 0, 0, 0.6)',
  // },
];